import React from 'react';
import { Hero } from '../components/home/Hero';
import { TrustStrip } from '../components/home/TrustStrip';
import { WhyUs } from '../components/home/WhyUs';
import { ServiceCards } from '../components/home/ServiceCards';
import { RecentWork } from '../components/home/RecentWork';
import { ReviewsCarousel } from '../components/home/ReviewsCarousel';
import { ProcessTeaser } from '../components/home/ProcessTeaser';
import { CtaBand } from '../components/shared/CtaBand';
import { useLanguage } from '../contexts/LanguageContext';
import { useSeo } from '../hooks/useSeo';
export function Home() {
  const {
    t,
    lang
  } = useLanguage();
  useSeo({
    ...t.common.seo.home,
    lang
  });
  return <main data-id="element-469" data-mp="2dhgrb1wthu9k">
      <Hero data-id="element-470" data-mp="2di8bzhovm7l2" />
      <TrustStrip data-id="element-471" data-mp="2dhytef65v2pe" />
      <ServiceCards data-id="element-472" data-mp="2dii6nikv92x3" />
      <WhyUs data-id="element-473" data-mp="2dfm41gy2pq2b" />
      <RecentWork data-id="element-474" data-mp="2dfdu9xx8z0vc" />
      <ReviewsCarousel data-id="element-475" data-mp="3kvk2ycd6qn2a" />
      <ProcessTeaser data-id="element-476" data-mp="3ku8sjtp8ih27" />
      <CtaBand data-id="element-477" data-mp="3kuqzbk9iwdod" />
    </main>;
}